import React from 'react';
import clsx from 'clsx';

import './index.scss';
import PcPopUp from 'components/molecules/PcPopUp';

const PcConfItem = ({ 
  text, 
  children, 
  questionMark,
  popUpTitle,
  popUpDetail, 
}) => {

  const DispTitle = () => {
    return Array.isArray(text)
      ? text.map(line => (
        <span key={line} className="">
          {line}
          <br />
        </span>
      ))
      : <>{text}</>;
  };
  const DispChildren = () =>{
    return Array.isArray(children)
      ? children.map(line => (
        <span key={line.label} className="">
          {line.label}
          <br />
        </span>
      ))
      : <>{children}</>;
  };

  return (
    <div className="PcConfItem">
      <div className="title-wrapper">
        <div className="title">
          <DispTitle />
          <span 
            className={clsx('QuestionMarkIcon',
              { qShow: questionMark === false })}
          >
            <PcPopUp title={popUpTitle}>{popUpDetail}</PcPopUp>
          </span>
        </div>
      </div>
      <div className="itemArea">
        <p className="">
          <DispChildren />
        </p>
      </div>
    </div>
  );
};

export default PcConfItem;